import Extract from "../pages/extract";

export default [
  { path: "/extract", component: Extract },
  { path: "/extract/:order", component: Extract },
];
